var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SideButtons',{attrs:{"buttons":_vm.buttons}})
}
var staticRenderFns = []

export { render, staticRenderFns }